import { render } from "./TagEditor.vue?vue&type=template&id=05ce9f0e"
import script from "./TagEditor.vue?vue&type=script&lang=js"
export * from "./TagEditor.vue?vue&type=script&lang=js"
script.render = render

export default script